import {Url, Controller} from './controller';
import {$_FILTERS} from './filters/all';
import {Parameter, ParamJson} from './parameter';
import {$_COLORS, Color} from './colors';

export interface FilterJson {
  title: string;
  description: string;
  params: ParamJson<any>[];

  color: string;
  power: number;
  scale: number;
  inv: boolean;

  firstWord: boolean;
  middleWords: boolean;
  lastWord: boolean;
}

export function slugify(s: string): string {
  return s.replace(' ', '_').toLocaleLowerCase();
}

let uniqueId = 1;
export abstract class Filter {
  static $_title: string;
  static $_description: string;
  abstract $_params: Parameter[];

  $_color: Color = $_COLORS.items[0];
  $_power: number = 1;
  $_scale: number = 1;
  $_inv: boolean = false;

  $_firstWord = true;
  $_middleWords = true;
  $_lastWord = true;

  $_invalidate = true;

  $_uniqueId = uniqueId++;

  constructor() {}

  serialize(): FilterJson {
    return {
      title: (this.constructor as typeof Filter).$_title,
      description: (this.constructor as typeof Filter).$_description,
      params: this.$_params.map(p => p.serialize()),
      color: this.$_color.serialize(),
      power: this.$_power,
      scale: this.$_scale,
      inv: this.$_inv,
      firstWord: this.$_firstWord,
      middleWords: this.$_middleWords,
      lastWord: this.$_lastWord,
    };
  }

  static deserialize(json: FilterJson): Filter {
    throw new Error('Not implemented');
  }

  $_cache: {[urlIndex: number]: number | null} = {};

  score(url: Url, controller: Controller): number | null {
    if (this.$_invalidate || controller.$_invalidate) {
      const result = this.$_score(url, controller);
      this.$_cache[url.$_index] = result;
      return result;
    }

    return this.$_cache[url.$_index];
  }

  /**
   * Score a given URL between -1.0 (negatively weight) and 1.0 (positively weight).
   * @param url A given URL.
   */
  abstract $_score(url: Url, controller: Controller): number | null;
}
